<aside class="ai-aside border d-flex bg-white border-left" [class.ai-aside--collapsed]="isCollapsed()"
    [class.ai-aside--mobile-open]="isMobileOpen()">
    <div class="ai-rail d-flex flex-column align-items-center position-relative">
        <button type="button" class="ai-rail__button btn text-white p-0 mt-1" (click)="togglePanel.emit()"
            [ngClass]="isCollapsed() ? 'btn-collapsed' : ''" [attr.aria-expanded]="!isCollapsed()"
            [attr.aria-label]="isCollapsed() ? 'Expand AI assistant' : 'Collapse AI assistant'">
            <i class="fa" [ngClass]="isCollapsed() ? 'fa-angle-left' : 'fa-angle-right'"></i>
        </button>
        <div class="ai-rail__title text-white position-absolute">{{ "aiReport.lbl_ai_assistant" | translate}}
        </div>
    </div>

    <div class="ai-body d-flex flex-column p-2 mr-4 w-100">
        @if (!isCollapsed()) {
            <!-- Chat (scrolls) -->
            <app-chat-message-list
                [messages]="facade.messages()"
                [isLoading]="facade.isChatLoading()"
                [isStreaming]="facade.isStreaming()" />

            <!-- Input -->
            <app-chat-input />
        }
    </div>
</aside>
